"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getTranslation = exports.getIntl = void 0;
var tslib_1 = require("tslib");
// (C) 2007-2022 GoodData Corporation
var isEmpty_1 = tslib_1.__importDefault(require("lodash/isEmpty"));
var react_intl_1 = require("react-intl");
var Locale_1 = require("./Locale");
var messagesMap_1 = require("./messagesMap");
var intlStore = {};
/**
 * Gets react-intl's IntlShape set up for the provided locale.
 *
 * @param locale - one of the supported locales, if not specified returns shape for `DefaultLocale`
 * @internal
 */
function getIntl(locale) {
    if (locale === void 0) { locale = Locale_1.DefaultLocale; }
    var usedLocale = locale;
    if (isEmpty_1.default(locale)) {
        usedLocale = Locale_1.DefaultLocale;
    }
    return (intlStore[usedLocale] ||
        (intlStore[usedLocale] = react_intl_1.createIntl({
            locale: usedLocale,
            messages: messagesMap_1.messagesMap[locale],
        })));
}
exports.getIntl = getIntl;
/**
 * Convenience function to return translated and formatted string for given key and locale; optionally specify
 * values of parameters to substitute in the translated string.
 *
 * @param translationId - id of the localized string
 * @param locale - target locale
 * @param values - parameters, optional
 *
 * @internal
 */
function getTranslation(translationId, locale, values) {
    if (values === void 0) { values = {}; }
    var intl = getIntl(locale);
    var desc = typeof translationId === "object"
        ? tslib_1.__assign(tslib_1.__assign({}, translationId), { defaultMessage: translationId.id }) : { id: translationId, defaultMessage: translationId };
    return intl.formatMessage(desc, values);
}
exports.getTranslation = getTranslation;
//# sourceMappingURL=IntlStore.js.map